module.exports = __webpack_public_path__ + "img/performance.327f9f00.svg";